export default {
  "Cut Audio": "剪切音频",
  "HitPaw Online Audio Cutter": "线上音频剪辑器",
  "Trim or cut any audio files online.": "在线剪切任何音频",
  "Cut": "剪切",
  "Fade in": "淡入",
  "Fade out": "淡出",
  "Cut from": "裁剪从",
  "to": "到",
  "Extract selection": "提取选定内容",
  "Delete selection": "删除选定内容",
  "Adjust New": "调节新的(音频)",
  "Cut New": "剪切新音频",
  "Adjust Volume": "调节音量",
  "HitPaw Online Volume Changer": "调节音频音量",
  "Turn up or Turn down the volume of audio.": "增加和减少音频音量",
  "Volume": "音量",
  "Change Speed": "调节速度",
  "HitPaw Online Audio Speed Changer": "调节音频速度",
  "Speed up or slow down audios online easily.": "轻松提高和降低音频速度",
  "Speed": "速度",
  "Format": "格式",
  "Size": "大小",
  "Duration": "时长",
};
